/**
 * サブヘッダー
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { Router } from '@angular/router';
import { CheckinMybookingService } from '@common/services';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { RESERVATION_DETAIL_IDENTIFIER } from '@common/interface';
import { CprResultStoreService } from '@common/services/cpr-result-store/cpr-result-store.service';
import { Observable, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PostJourneysGetJourneyResponse } from 'src/sdk_checkin';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-checkin-mybooking-sub-header',
  templateUrl: './checkin-mybooking-sub-header.component.html',
  providers: [CheckinMybookingService, CprResultStoreService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinMybookingSubHeaderComponent extends CheckinBaseComponent {
  private cprResult$: Observable<PostJourneysGetJourneyResponse>;
  /** 戻るボタンを表示するかどうかのフラグ */
  isDisplayBackButton: boolean = false;
  isTransitionFromServicingMybooking: boolean = false;

  constructor(
    common: CommonLibService,
    private checkinCommonStoreService: CheckinCommonStoreService,
    private checkinMybookingService: CheckinMybookingService,
    private router: Router,
    private cprResultStoreService: CprResultStoreService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(common);
    this.cprResult$ = cprResultStoreService
      .getCprResult$()
      .pipe(filter((cprResult) => !!cprResult)) as Observable<PostJourneysGetJourneyResponse>;
  }

  reload(): void {}
  init(): void {
    this.subscribeService(
      combineLatest([this.cprResult$, this.checkinCommonStoreService.getCheckinCommonState$()]),
      ([_, checkinCommon]) => {
        // 遷移元が予約詳細かつ、キャビンクラスが混在していない場合に、戻るボタンを表示する
        const isCabinClassMixed = this.cprResultStoreService.isCabinClassMixed();
        this.isTransitionFromServicingMybooking =
          checkinCommon.reservationDetailIdentifier === RESERVATION_DETAIL_IDENTIFIER;

        // 予約詳細からの遷移かつキャビンクラスが混在の場合には予約詳細に戻させない
        // どの画面からの遷移かを示す識別子がチェックイン確認である場合には表示させない
        this.isDisplayBackButton = !(
          (isCabinClassMixed && this.isTransitionFromServicingMybooking) ||
          checkinCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.CHECKIN_COMPLETED
        );
        this.changeDetectorRef.markForCheck();
      }
    );
  }
  destroy(): void {}

  /**
   * 戻るボタン押下処理
   */
  onClickBackButton(): void {
    if (this.isTransitionFromServicingMybooking) {
      this.checkinMybookingService.backToServicingMybooking();
      return;
    }
    this.router.navigate([CHECKIN_ROUTES.checkinSearch]);
  }
}
